export function ArrowRight() {
  return (
    <svg width="6" height="11" viewBox="0 0 6 11" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M5.85355 5.94269C6.04882 5.74742 6.04881 5.43084 5.85355 5.23558L1.26442 0.646446C1.06916 0.451184 0.752577 0.451184 0.557315 0.646446C0.362052 0.841708 0.362052 1.15829 0.557314 1.35355L4.79642 5.59266L0.552015 9.83706C0.357727 10.0313 0.357727 10.3464 0.552015 10.5406C0.746304 10.7349 1.06131 10.7349 1.2556 10.5406L5.85355 5.94269Z"
        fill="black"
      />
    </svg>
  );
}
